// extracted by mini-css-extract-plugin
export default {"shortWrapper":"views-ProductPage-themes-BGH-productAccordion__shortWrapper--ESMjR","sectionHeader":"views-ProductPage-themes-BGH-productAccordion__sectionHeader--mqDcM"};